import React from "react";
import { Spin, Row, Col, Radio } from "antd";
import global from "../../../common/utility/global";
import Header from "../../../components/Header";
import Filters from "./Filters";
import KpiCard from "./KpiCard";
import ChartPanel from "./ChartPanel";
import anioMock from '../../../common/mock/anioMock';
import mesMock from '../../../common/mock/mesMock';
import GraficoTopProductos from "./GraficoTopProductos";
import GraficoEvolucionProductos from "./GraficoEvolucionProductos";
import GraficoParticipacionProductos from "./GraficoParticipacionProductos";
import { buildDashboardData, formatCurrency, formatNumber } from "./utils";
import "./styles.css";
import comprobanteService from "../../../service/ventas/comprobanteService";

export default class Index extends React.Component {
    constructor(props) {
        super(props);
        const filter = {
            anioInicio: global.fetchCurrentYear(),
            mesInicio: global.fetchCurrentMonth(),
            anioFin: global.fetchCurrentYear(),
            mesFin: global.fetchCurrentMonth(),
            flagNotaVenta: false,
        };
        this.state = {
            loading: true,
            moneda: "PEN",
            anios: anioMock.values,
            meses: mesMock.values,
            filter,
            dashboard: buildDashboardData(null, filter),
        };
    }

    handleChange = (property, value) => {
        const filter = { ...this.state.filter, [property]: value };
        this.setState({ filter });
    };

    handleChangeMoneda = (e) => {
        this.setState({ moneda: e.target.value });
    };

    handleClearFilters = () => {
        const filter = {
            anioInicio: global.fetchCurrentYear(),
            mesInicio: global.fetchCurrentMonth(),
            anioFin: global.fetchCurrentYear(),
            mesFin: global.fetchCurrentMonth(),
            flagNotaVenta: false,
        };
        this.setState({ filter, moneda: "PEN" });
        this.handleGenerateReport(filter);
    };

    handleGenerateReport = async (filter) => {
        this.setState({ loading: true });
        try {
            const response = await comprobanteService.dashboardProducto(filter);
            this.setState({ dashboard: buildDashboardData(response, filter) });
        } finally {
            this.setState({ loading: false });
        }
    };

    async componentDidMount() {
        await this.handleGenerateReport(this.state.filter);
    }

    render() {
        const { moneda, filter } = this.state;
        const { kpis, topProductos, evolucion, participacion } = this.state.dashboard;
        const clave = moneda === "USD" ? "usd" : "pen";
        const esMismoMes = filter.anioInicio === filter.anioFin && filter.mesInicio === filter.mesFin;
        const tituloEvolucion = `Ventas por Producto (Evolución ${esMismoMes ? "diaria" : "mensual"})`;

        return (
            <div>
                <Header
                    title="Dashboard de Ventas por Producto"
                    onClearFilters={this.handleClearFilters}
                    onSearch={() => this.handleGenerateReport(this.state.filter)}
                />
                <Filters filter={this.state.filter} anios={this.state.anios} meses={this.state.meses} onChange={this.handleChange} />
                <div className="moneda-toggle">
                    <Radio.Group value={moneda} onChange={this.handleChangeMoneda} buttonStyle="solid">
                        <Radio.Button value="PEN">S/ Soles</Radio.Button>
                        <Radio.Button value="USD">US$ Dólares</Radio.Button>
                    </Radio.Group>
                </div>
                <Spin tip="Cargando..." size="large" spinning={this.state.loading}>
                    <div className="kpi-row">
                        <KpiCard
                            icon="shopping"
                            iconColor="#2563eb"
                            iconBackground="#dbeafe"
                            label="Total Ventas (Periodo)"
                            value={formatCurrency(kpis.totalVentas[clave].valor, moneda)}
                            tendenciaDireccion={kpis.totalVentas[clave].tendenciaDireccion}
                            tendenciaTexto={`${formatNumber(kpis.totalVentas[clave].tendenciaPct)}% vs periodo anterior`}
                        />
                        <KpiCard
                            icon="appstore"
                            iconColor="#16a34a"
                            iconBackground="#dcfce7"
                            label="Productos Vendidos (SKU)"
                            value={kpis.productosVendidos.valor}
                            tendenciaDireccion={kpis.productosVendidos.tendenciaDireccion}
                            tendenciaTexto={`${formatNumber(kpis.productosVendidos.tendenciaPct)}% vs periodo anterior`}
                        />
                        <KpiCard
                            icon="shopping-cart"
                            iconColor="#7c3aed"
                            iconBackground="#ede9fe"
                            label="Cantidad de Cpe"
                            value={formatNumber(kpis.cantidadCpe.valor, 0)}
                            tendenciaDireccion={kpis.cantidadCpe.tendenciaDireccion}
                            tendenciaTexto={`${formatNumber(kpis.cantidadCpe.tendenciaPct)}% vs periodo anterior`}
                        />
                        <KpiCard
                            icon="dollar"
                            iconColor="#ea580c"
                            iconBackground="#ffedd5"
                            label="Cpe Promedio"
                            value={formatCurrency(kpis.cpePromedio[clave].valor, moneda)}
                            tendenciaDireccion={kpis.cpePromedio[clave].tendenciaDireccion}
                            tendenciaTexto={`${formatNumber(kpis.cpePromedio[clave].tendenciaPct)}% vs periodo anterior`}
                        />
                        <KpiCard
                            icon="percentage"
                            iconColor="#dc2626"
                            iconBackground="#fee2e2"
                            label="% Concentración Top 10"
                            value={`${formatNumber(kpis.concentracionTop10[clave].valor)}%`}
                            tendenciaDireccion={kpis.concentracionTop10[clave].tendenciaDireccion}
                        />
                    </div>

                    <Row gutter={16}>
                        <Col className="gutter-row" xs={24} lg={12}>
                            <ChartPanel title="Top 10 Productos por Ventas">
                                <GraficoTopProductos
                                    productos={topProductos[clave].map((item) => item.nombre)}
                                    valores={topProductos[clave].map((item) => item.valor)}
                                    moneda={moneda}
                                />
                            </ChartPanel>
                        </Col>

                        <Col className="gutter-row" xs={24} lg={12}>
                            <ChartPanel title="Ventas por Participación de Productos">
                                <GraficoParticipacionProductos datos={participacion[clave]} moneda={moneda} />
                            </ChartPanel>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col className="gutter-row" span={24}>
                            <ChartPanel title={tituloEvolucion}>
                                <GraficoEvolucionProductos
                                    timeLine={evolucion.timeLine}
                                    series={evolucion[clave]}
                                    moneda={moneda}
                                />
                            </ChartPanel>
                        </Col>
                    </Row>
                </Spin>
            </div>
        );
    }
}
